/// <reference path="../../../typescript/phaser.d.ts"/>
/// <reference path="../../GameVars.ts"/>
/// <reference path="../FieldBoundaries.ts"/>

import { GameVars } from "../../GameVars";

import { GameConstants } from "../../GameConstants";

import { FieldBoundaries } from "../FieldBoundaries";

import { AudioManager } from "../../AudioManager";

export class GoalKeeper extends Phaser.Sprite {

    private static MOVING_STATE: string = "moving";
    private static STILL_STATE: string = "still";
    private static HORIZONTAL_SPEED: number = 200;

    private static IDLE_ANIMATION: string = "idle";
    private static SAVE_ANIMATION: string = "save";
    private static GOAL_ANIMATION: string = "goal";

    public canBeHit: boolean;
    public cursed: boolean;
    public frozen: boolean;
    public canBeAffectedByVoodoo: boolean;

    private textureIdle: string;
    private textureIdleBlink: string;
    private textureSave: string;
    private textureGoal: string;

    private iceSprite: Phaser.Sprite;

    private isElectric: boolean;
    private electricGlovesAnimation: Phaser.Sprite;

    private updateAllowed: boolean;

    private currentState: string;

    private leftLimitOnPenalty: number;
    private rightLimitOnPenalty: number;
    private smokeSprite: Phaser.Sprite;

    constructor(game: Phaser.Game, x: number, y: number) {

        super(game, x, y, "" + GameVars.adversaryID);

        this.canBeHit = true;
        this.cursed = false;
        this.frozen = false;
        this.canBeAffectedByVoodoo = true;

        this.isElectric = GameVars.goalKeeperType === "normal" ? false : true;
        this.updateAllowed = true;
        this.iceSprite = null;
        this.smokeSprite = null;

        let adversaryID: number = GameVars.adversaryID;

        let idle_eyes_open_frame_ID: number = (adversaryID - 1) * 4 + 1;
        let idle_blink_frame_ID: number = (adversaryID - 1) * 4 + 2;
        let on_save_fame_ID: number = (adversaryID - 1) * 4 + 3;
        let on_goal_frame_ID: number = (adversaryID - 1) * 4 + 4;

        this.textureIdle = "portero_" + GameVars.formatNumberForTextureAtlas(idle_eyes_open_frame_ID);
        this.textureIdleBlink = "portero_" + GameVars.formatNumberForTextureAtlas(idle_blink_frame_ID);
        this.textureSave = "portero_" + GameVars.formatNumberForTextureAtlas(on_save_fame_ID);
        this.textureGoal = "portero_" + GameVars.formatNumberForTextureAtlas(on_goal_frame_ID);

        this.frameName = this.textureIdle;

        this.game.physics.p2.enable(this, GameConstants.SHOW_PHYSICS_BODIES);

        this.alpha = GameConstants.ALPHA_PHYSICS_BODIES;

        this.anchor.set(.5);

        this.body.clearShapes();

        this.body.addPolygon([true, true, true], [
            20, 35,
            50, 5,
            93.5, 0,
            137, 5,
            167, 35,
            167, 85,
            20, 85
        ]);

        this.body.allowRotation = false;
        this.body.kinematic = true;
        this.body.setMaterial(GameVars.getInstance().materials.goalkeeperMaterial);
        this.body.mass = 10e8;

        this.body.velocity.x = GoalKeeper.HORIZONTAL_SPEED;

        // los guantes electricos
        if (this.isElectric) {

            this.electricGlovesAnimation = new Phaser.Sprite(this.game, 0, 0, "texture_atlas_1");
            this.electricGlovesAnimation.animations.add(GoalKeeper.IDLE_ANIMATION, Phaser.Animation.generateFrameNames("manos_electricas", 1, 4, "", 4), 12, true);
            this.electricGlovesAnimation.animations.add(GoalKeeper.SAVE_ANIMATION, Phaser.Animation.generateFrameNames("manos_electricas", 5, 8, "", 4), 12, true);
            this.electricGlovesAnimation.animations.add(GoalKeeper.GOAL_ANIMATION, Phaser.Animation.generateFrameNames("manos_electricas", 9, 11, "", 4), 12, true);
            this.electricGlovesAnimation.anchor.set(.5);
            this.addChild(this.electricGlovesAnimation);

            this.electricGlovesAnimation.play(GoalKeeper.IDLE_ANIMATION);

            this.name = GameConstants.ELECTRIC_GOALKEEPER;

        } else {

            this.name = GameConstants.GOALKEEPER;
        }

        this.currentState = GoalKeeper.MOVING_STATE;

        // los limites por donde se mueve cuando hay penalty
        this.leftLimitOnPenalty = FieldBoundaries.LEFT_POST_PX;
        this.rightLimitOnPenalty = FieldBoundaries.LEFT_POST_PX + FieldBoundaries.DELTA_X_POST;
    }

    public update(): void {

        if (this.updateAllowed) {

            if (this.x > FieldBoundaries.LEFT_POST_PX + FieldBoundaries.DELTA_X_POST) {
                this.body.velocity.x = - GoalKeeper.HORIZONTAL_SPEED;

                if (GameVars.isGoalKeeperDuck) {
                    this.scale.set(-1, 1);
                }
            }

            if (this.x < FieldBoundaries.LEFT_POST_PX) {
                this.body.velocity.x = GoalKeeper.HORIZONTAL_SPEED;

                if (GameVars.isGoalKeeperDuck) {
                    this.scale.set(1);
                }
            }
        }
    }

    public hit(): void {

        if (this.frozen) {
            return;
        }

        if (this.currentState === GoalKeeper.MOVING_STATE) {

            this.frameName = this.textureSave;

            if (this.isElectric) {
                this.electricGlovesAnimation.play(GoalKeeper.SAVE_ANIMATION);
            }

            this.game.time.events.add(350, this.restart, this);
        }

        if (this.name === GameConstants.DUCK) {
            AudioManager.getInstance().playEffect("quack_risa");
        } else {
            let rnd: number = Math.random();
            if (rnd > .66) {
                AudioManager.getInstance().playEffect("risa_portero_1");
            } else if (rnd > .33) {
                AudioManager.getInstance().playEffect("risa_portero_2");
            } else {
                AudioManager.getInstance().playEffect("risa_portero_3");
            }
        }
    }

    public onFreezeGoalKeeper(): void {

        if (this.cursed) {
            return;
        }

        this.frozen = true;
        this.name = GameConstants.FROZEN_GOALKEEPER;

        this.updateAllowed = false;
        this.body.velocity.x = 0;

        if (this.isElectric) {
            this.electricGlovesAnimation.visible = false;
        }

        // cambiamos la forma del cuerpo para que la pelota no se quede atrapada encima
        this.body.setMaterial(GameVars.getInstance().materials.frozenGoalkeeperMaterial);

        let iceImageName: string = GameVars.isGoalKeeperDuck ? "duck-iceblock" : "goalkeeper-iceblock";

        this.iceSprite = new Phaser.Sprite(this.game, 0, 0, "texture_atlas_1", iceImageName);
        this.iceSprite.anchor.set(.5);
        this.addChild(this.iceSprite);
    }

    public onNoBallsInTheField(): void {

        if (this.frozen) {

            this.frozen = false;
            this.updateAllowed = true;

            if (this.isElectric) {
                this.name = GameConstants.ELECTRIC_GOALKEEPER;
                this.electricGlovesAnimation.visible = true;
            } else {
                this.name = GameConstants.GOALKEEPER;
            }

            this.game.add.tween(this.iceSprite)
                .to({ alpha: 0 }, 400, Phaser.Easing.Cubic.Out, true)
                .onComplete.add(function (): void {
                    this.iceSprite.destroy();
                }, this);

            this.body.velocity.x = GoalKeeper.HORIZONTAL_SPEED;

            // vuelve a tener el material  original
            this.body.setMaterial(GameVars.getInstance().materials.goalkeeperMaterial);

            this.restart();
        }
    }

    // con el update de phaser surge el problema de que el portero no se 
    // deja destruir, por esto lo transformamos en sensor
    public makeVoodoo(): void {

        this.updateAllowed = false;
        this.body.velocity.x = 0;

        this.cursed = true;

        this.game.time.events.add(1500 + Math.random() * 1000, function (): void {

            this.smokeSprite = new Phaser.Sprite(this.game, 0, 0, "texture_atlas_1", "humo_0001");
            this.smokeSprite.animations.add("burn", Phaser.Animation.generateFrameNames("humo_", 1, 5, "", 4), 8, true);
            this.smokeSprite.anchor.set(.5);
            this.addChild(this.smokeSprite);
            let burnAnimation: any = this.smokeSprite.animations.play("burn", 16, false, true);
            burnAnimation.onComplete.add(function (): void {
                this.visible = false;
                this.body.data.shapes[0].sensor = true;
            }, this);

        }, this);
    }

    public onGoal(): void {

        if (this.cursed || this.frozen) {
            return;
        }

        if (this.currentState === GoalKeeper.MOVING_STATE) {

            this.body.velocity.x = 0;
            this.frameName = this.textureGoal;

            if (this.isElectric) {
                this.electricGlovesAnimation.play(GoalKeeper.GOAL_ANIMATION);
            }

            this.currentState = GoalKeeper.STILL_STATE;
            this.game.time.events.add(1500, this.restart, this);
        }

        if (this.name === GameConstants.DUCK) {
            AudioManager.getInstance().playEffect("quack_goal");
        }
    }

    public restart(): void {

        if (this.cursed) {
            return;
        }

        if (this.currentState === GoalKeeper.STILL_STATE) {
            this.body.velocity.x = Math.random() > .5 ? GoalKeeper.HORIZONTAL_SPEED : - GoalKeeper.HORIZONTAL_SPEED;
            this.currentState = GoalKeeper.MOVING_STATE;
        }

        if (this.frameName !== this.textureIdle) {
            this.frameName = this.textureIdle;

            if (this.isElectric) {
                this.electricGlovesAnimation.play(GoalKeeper.IDLE_ANIMATION);
            }
        }
    }

    public blink(): void {

        if (this.cursed || this.frozen || this.frameName !== this.textureIdle) {
            return;
        }

        this.frameName = this.textureIdleBlink;

        if (GameVars.isGoalKeeperDuck && !GameVars.paused) {
            AudioManager.getInstance().playEffect("quack");
        }

        this.game.time.events.add(100, this.returnToIdle, this);
    }

    public shrink(): void {

        // para desactivar el portero electrico si lo fuese
        this.name = GameConstants.DUCK;

        // considerar el caso de que fuese un portero electrico
        if (this.isElectric) {
            this.electricGlovesAnimation.destroy();
        }

        this.updateAllowed = false;

        this.body.velocity.x = 0;

        // la animacion que se pone por encima
        var duckTransformationAnimation: Phaser.Sprite = new Phaser.Sprite(this.game, 0, 0, "texture_atlas_1");
        duckTransformationAnimation.animations.add("transformation", Phaser.Animation.generateFrameNames("fx_pato_portero_", 1, 6, "", 4), 8, false);
        duckTransformationAnimation.animations.play("transformation", 8, false, true);
        duckTransformationAnimation.anchor.setTo(.5);
        this.addChild(duckTransformationAnimation);

        this.game.add.tween(this.scale)
            .to({ x: 1.35, y: 1 }, 350, Phaser.Easing.Elastic.In, false, 150)
            .to({ x: .6, y: 1.25 }, 350, Phaser.Easing.Elastic.Out)
            .to({ x: .45, y: .45 }, 400, Phaser.Easing.Elastic.InOut)
            .start();

        // no llamaba al callback al terminar el ultimo tween sino el primero
        this.game.time.events.add(1500, this.transformInToDuck, this);
    }

    private returnToIdle(): void {

        this.frameName = this.textureIdle;
    }

    private transformInToDuck(): void {

        if (this.cursed) {
            return;
        }

        this.scale.set(-1, 1);

        this.updateAllowed = true;

        this.body.setCircle(32);
        this.body.setMaterial(GameVars.getInstance().materials.duckMaterial);

        if (!this.frozen) {
            this.updateAllowed = true;
            this.body.velocity.x = - GoalKeeper.HORIZONTAL_SPEED;
        } else {
            this.iceSprite.frameName = "duck-iceblock";
        }

        // cuidado porque el patito tiene que estar en el mismo atlas de texturas
        this.textureIdle = "duck_idle_0";
        this.textureIdleBlink = "duck_idle_1";
        this.textureSave = "duck_on_save";
        this.textureGoal = "duck_on_goal";

        this.frameName = this.textureIdle;
    }
}
